export const QUERY_KEYS = {
	report: (reportId: string, key: string) => ["report", reportId, key] as const,
	reportForm: (reportId: string, key: string) =>
		["report-form", reportId, key] as const,
	reportTrips: (reportId: string, key: string) =>
		["report-trips", reportId, key] as const,
} as const
